/**
 * cqt三端分享聚合
**/
import Vue from 'vue'
import { platformEnv } from '@/utils/platformConfig.js'
import TSharePop from './TSharePop.vue'
import api from '@/services/commonApi'
import { setBnbMpShare } from '@tujia/fe-lib-bridge/lib'
import { channelTypes, getChannelInfo } from '@common-libs/tj-channel'
const channelId = getChannelInfo().channelId

// 挂载途家分享弹窗
const v = new Vue({
  render(createElement) {
    return createElement(TSharePop)
  }
})
v.$mount()
document.body.appendChild(v.$el)
const tShare = v.$children[0]
// shareConfig: { title, desc, link, imageUrl, timelineImg, goLink }
let shareConfig = {}

const TShare = (opt) => {
  tShare.showPopup(opt || shareConfig)
}

// 呼起C端分享
const CShare = (opt) => {
  const { title, link, desc, imageUrl, timelineImg } = shareConfig
  // 修改后途家线上地址
  let miniProgramProductUrl = `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(link)}&needLogin=true`
  let dataList = [
    // 微信分享好友
    {
      shareType: 'WeixinFriend',
      imageUrl,
      title,
      text: desc,
      linkUrl: 'https://www.ctrip.com',
      miniProgramPath: miniProgramProductUrl // 如果传递该参数，就表示分享到小程序给好友
    },
    // 微信朋友圈
    {
      shareType: 'WeixinCircle', // 朋友圈只显示title
      imageUrl: timelineImg || imageUrl,
      text: desc,
      title,
      linkUrl: `https://m.ctrip.com/webapp/newbnb/transform.html?islogin=1&targeturl=${encodeURIComponent(encodeURIComponent(link))}`,
      timelineTitle: desc
    }
  ]
  window.CtripShare.app_call_custom_share(dataList)
}

// 呼起Q端分享
const QShare = (opt) => {
  const { title, link, desc, imageUrl } = shareConfig
  window.hysdk && window.hysdk.ready((res) => {
    window.hysdk.share.share({
      shareInfos: [{
        shareType: 'WechatFriends',
        imageUrl,
        title: title,
        text: desc,
        miniProgramPath: `/pages/alonePlatform/webView/index?url=${encodeURIComponent(link)}`,
        miniProgramUserName: 'gh_7ffb9c5d761f',
        shareHdImageURL: imageUrl,
        miniProgramType: 'release',
        imgCompress: 'original'
      }, {
        shareType: 'Default', // 表示其他未指定的平台，都适用该分享内容
        imageUrl,
        title: title,
        text: desc,
        linkUrl: link
      }],
      options: {},
      success: function(e) {},
      fail: function(e) {}
    })
  })
}

// 1.保存分享参数
// 2.设置小程序右上角、微信内嵌浏览器右上角分享
const initPageShare = (shareInfo) => {
  const { title, desc, link, imageUrl } = shareInfo
  shareConfig = shareInfo
  // 微信浏览器
  if (platformEnv.isWxBrowser && shareInfo) {
    const shareObj = {
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl: imageUrl // 分享图标
    }
    api.getWechatJsSdkConfig({ url: window.location.href }).then((res) => {
      let data = {}
      if (res.isSuccess && res.data) {
        data = res.data
      }
      window.wx && window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      })
      window.wx && window.wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareTimeline(shareObj)
        window.wx.onMenuShareAppMessage(shareObj)
      })
    }).catch((res) => {})
  }
  // 小程序右上角分享
  // setBnbMpShare 对 T 有错误，先用 postMessage
  if (channelId === channelTypes.TUJIA) {
    window.wx && window.wx.miniProgram.postMessage({
      data: {
        msgKey: 'onShare',
        msgData: {
          title,
          imageUrl,
          path: '/pages/tbnb/pages/common/webview/index?h5url=' + encodeURIComponent(link)
        }
      }
    })
  } else if (window.location.href.indexOf('bnb.qunar.com') > -1) {
    window.wx && window.wx.miniProgram.postMessage({
      data: {
        name: 'updateShareInfo',
        title,
        imageUrl,
        path: `/pages/alonePlatform/webView/index?url=${encodeURIComponent(link)}`
      }
    })
  } else {
    setBnbMpShare({
      title,
      url: link,
      imageUrl
    })
  }
}

const TCShare = (opt) => {
  if (platformEnv.isTujiaAppEnv) {
    TShare(opt)
  }
  if (platformEnv.isCtripAppEnv) {
    CShare(opt)
  }
}

export { initPageShare, TShare, CShare, QShare, TCShare }
